export default __webpack_public_path__ + "static/media/DrumMockUp.a16fac6d.jpg";